import { Typography as MuiTypography } from '@mui/material'
import styled from 'styled-components'

type FontWeight = 400 | 500 | 600 | 700

type Props = {
  title?: string | number
  fontWeight?: FontWeight
  'data-testid'?: string
}

const StyledTypography = styled(MuiTypography)<{ $fontWeight: FontWeight }>`
  &.MuiTypography-root {
    font-weight: ${(props) => props.$fontWeight};
    font-size: 18px;
    color: #000000;
    letter-spacing: 0.2px;
  }
`

function HeadingTwo({ title, fontWeight = 400, 'data-testid': testId }: Props) {
  return (
    <StyledTypography $fontWeight={fontWeight} data-testid={testId}>
      {title}
    </StyledTypography>
  )
}

export default HeadingTwo
